import { apiClient } from "api";
import { TSpecialityPicklist } from "./models/types";

export const getAllSpecialityList = async (): Promise<TSpecialityPicklist[]> => {
  const response = await apiClient.get(`speciality/GetSpecialities`);
  return response.data;
};
